export default "__VITE_ASSET__Ccy4dcvy__"